import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ProductLeftComponent } from '../../../app/content/modules/page/components/product/components/product-left/product-left.component';
import { withCommonDecorators } from '../../_utils/story-helpers';
import { createDamilanoBarberaProduct, createDiscountedProduct, createOutOfStockProduct, createLastBottlesProduct } from '../../_mocks/wine-product.mock';

const meta: Meta<ProductLeftComponent> = {
  title: 'Organisms/Product/Product Left',
  component: ProductLeftComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'padded',
  },
};

export default meta;
type Story = StoryObj<ProductLeftComponent>;

export const Default: Story = {
  args: {
    product: createDamilanoBarberaProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-image-description, .product-header')).toBeTruthy();
  },
};

export const Discounted: Story = {
  args: {
    product: createDiscountedProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-image-description, .product-header')).toBeTruthy();
  },
};

export const OutOfStock: Story = {
  args: {
    product: createOutOfStockProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-image-description, .product-header')).toBeTruthy();
  },
};

export const LastBottles: Story = {
  args: {
    product: createLastBottlesProduct(),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('.product-image-description, .product-header')).toBeTruthy();
  },
};

export const NoImages: Story = {
  args: {
    product: createDamilanoBarberaProduct({ images: [] }),
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-left')).toBeTruthy();
  },
};
